export default __webpack_public_path__ + "static/media/delivery-truck-delivery-svgrepo-com.0ef44ec1.svg";